import { render, staticRenderFns } from "./CartOverview.vue?vue&type=template&id=1f267155&"
import script from "./CartOverview.vue?vue&type=script&lang=ts&"
export * from "./CartOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CartOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports